/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditStagesAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import StagesDialog from './StagesDialog/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditStagesAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/EmployeeTable/Content/ActionsAction/Content/Content/EditStagesAction",
  isSubmitting,
  closePopover
  
}) {
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let boardStagesValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'stages',
})
let subscriberStagesValueData = fromData.useDataValue({ viewPath,
context: 'subscriber',
path: 'stages',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isSubmitting,
  closePopover
  
})
  return (<React.Fragment
>
<div
  data-testid="EditStagesAction.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 width={260}
 offsetCrossAxis={-252}
 offsetMainAxis={-30}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 alignSelf="flex-start"
 data="selected"
 disabled={selectedIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Edit stages subscribed to"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowForward
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<StagesDialog
{...childProps}
  viewPath={`${viewPath}/StagesDialog`}
 data="board.stages"
 stages={boardStagesValueData}
 data="subscriber.stages"
 selectedStages={subscriberStagesValueData}
 onSubmit={onSubmit}
 title="Stages subscribed to"
 closePopover={closePopover}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}